import React from 'react';
import MonthDayField from '../MonthDayField/MonthDayField';
import ToggleField from '../ToggleField/ToggleField';

export default function DateRangeToggle({
  yearRound,
  onYearRoundChange,
  startMonth,
  startDay,
  endMonth,
  endDay,
  onChange,
  errors = {},
  loading = false,
  disabled = false,
  className = '',
}) {
  return (
    <div className={className}>
      <ToggleField
        label="Send year-round"
        checked={yearRound}
        onChange={onYearRoundChange}
        loading={loading}
        disabled={disabled}
      />

      {!yearRound && (
        <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2">
          <MonthDayField
            label="Active from"
            month={startMonth}
            day={startDay}
            onChange={({ month, day }) => onChange({
              rangeStartMonth: month,
              rangeStartDay: day,
              rangeEndMonth: endMonth,
              rangeEndDay: endDay,
            })}
            error={errors.start}
            loading={loading}
            disabled={disabled}
          />
          <MonthDayField
            label="Active until"
            month={endMonth}
            day={endDay}
            onChange={({ month, day }) => onChange({
              rangeStartMonth: startMonth,
              rangeStartDay: startDay,
              rangeEndMonth: month,
              rangeEndDay: day,
            })}
            error={errors.end}
            loading={loading}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}
